var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.574h-0.506c-0.534 0 -1.04 0.207 -1.414 0.581l-1.141 1.127a1.349 1.349 0 0 1 -1.887 0l-1.141 -1.127a2 2 0 0 0 -1.414 -0.581H4a1.989 1.989 0 0 1 -2 -1.981V3.32A1.989 1.989 0 0 1 4 1.339h8c1.106 0 2 0.887 2 1.981v7.273c0 1.087 -0.894 1.981 -2 1.981",
    stroke: "#1D2023",
    strokeWidth: 1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.666a1.553 1.553 0 1 0 0 -3.106 1.553 1.553 0 0 0 0 3.106",
    stroke: "#1D2023",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 10.44c0 -1.2 -1.193 -2.174 -2.666 -2.174s-2.666 0.974 -2.666 2.174",
    stroke: "#1D2023",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.d50a58abec801dee6f1e9db9c3bc459a.svg";
export { ForwardRef as ReactComponent };